export class Opros {
	loadQuestions() {
		$.ajax({
			url: "/ajax.php?mid=116",
			type: 'POST',
			data: {
				action: "get",
			},
			dataType: "json",
			success: (res) => {
				const data = JSON.parse(res);
				const questions = data['questions'];
				const answers = data['answers'];
				this.questions = questions;
				this.answers = answers;
				putQuestions();
			},
			error: (err) => {
				alert("Не удалось загрузить вопросы");
				console.log(err);
			}
		});	
	}

	putQuestions() {
		// надо динамически создавать группы вопросов и ответов
		const questionsGroups = $(".question");
		for (let i = 0; i < questionsGroups.length; i++) {
			const questionTag = questionsGroups.find(".question-text");
			questionTag.html(this.questions[i]['question']);
			const answerElements = questionsGroups[i].find(".answer-text");
			for (let j = 0; j < answerElements.length; j++) {
				answerElements[j].html(this.answers[i][j]);
			}
		}
	}

	sendAnswers() {
		let formData = $("form.form.popup-survey__form").serializeArray();
		console.log(formData);
		formData = JSON.stringify(formData);
		// const userAnswers = getAnswers();
		$.ajax({
			url: "/ajax.php?mid=116",
			type: 'POST',
			data: {
				action: 'vote',
				data: formData
			},
			dataType: "json",
			success: (res) => {
				$("form.form.popup-survey__form").hide();
				const newDiv = $('<div class="text-block"></div>').text('Спасибо за ответы!');
				$(".popup__card-content").append(newDiv);
			},
			error: (err) => {
				$("form.form.popup-survey__form").hide();
				const newDiv = $('<div class="text-block"></div>').text('Не удалось отправить ответы, попробуйте снова!');
				$(".popup__card-content").append(newDiv);
			}
		});
	}

	getAnswers() {
		let userAnswers = [];
		// select values from html
		const questionsGroups = $(".question");
		for (let i = 0; i < questionsGroups.length; i++) {
			const questionTag = questionsGroups.find(".question-text");
			const answerElement = questionsGroups[i].find(".answer-text");
			userAnswers.push(answerElements.html());
		}

		return userAnswers;
	}
}
